import { ObservableObject } from './patch';

export type ObservableDataValueType = any;
// const ObservableStoreMap = new Map<string, BehaviorSubject<ObservableDataValueType>>();
export const observableStoreOp = new ObservableObject();
